import { Col, Row } from "antd";
import { useState } from "react";
import { useAppSelector } from "../../redux/store/storehooks";
import FormContainer from "../../components/FormContainer/FormContainer";
import { useNavigate } from "react-router-dom";
import { addPaymentgetwayFiles } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";

interface customProps {
    fileId: number,
    requestId: number,
    labId: number,
    base64File: any,
    fileName: string,
    fileExtension: string,
    isImportant: boolean,
    isDisable: boolean
}

const NewPaymentRequestFiles = () => {

    const [showFile1Img, setshowFile1Img] = useState(false);
    const [showFile2Img, setshowFile2Img] = useState(false);

    const [File1Img, setFile1Img] = useState(undefined);
    const [File2Img, setFile2Img] = useState(undefined);
    const myStore = useAppSelector((state) => state)
    const navigate = useNavigate();

    const [files,setFiles] = useState<any>([]);
    const [showImg, setshowImg] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmiting, setIsSubmiting] = useState(false);

    const convertToBase64 = (e: any) => {
        const file = e.target.files[0];

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = () => {
            const image:customProps= {
                fileId: 0,
                requestId: 131,
                labId: Number(myStore.auth.userId),
                base64File: reader.result,
                fileName: file.name,
                fileExtension: file.type,
                isImportant: true,
                isDisable: true
            };

            setFiles((prevArr:any) => {
                const result:any = [...prevArr];
                result.push(image)
                return result;
              });

              
              //var key = e.target.getAttribute('key');
              var key = e.target.getAttribute("data-index");
              setshowImg((prevArr) => {
                const result:any = [...prevArr];
                result[key] = true;
                return result;
              });
        };

        reader.onerror = (error) => {
            console.log('Error: ', error);
        };
    };

    const onCancelForm = () => {
        navigate("/labuser/RequestPayment")
    }

    const onSubmitForm = (e: any) => {

        e.preventDefault();

        addPaymentgetwayFiles(files)
            .then((result: any) => {


                sucessNotify("اطلاعات با موفقیت ذخیره شده", undefined, 5000)
                navigate("/labuser/RequestPayment");
                setIsLoading(false);

            })
            .catch((error) => {
                console.log(error);
                errorNotify(error.response.data.errorMessage, undefined, 5000)

            })

        // navigate("/labuser/NewPaymentRequestFiles");
        //  setIsLoading(false);
        setIsSubmiting(true);
    }

    return (
        <>
         <FormContainer onSubmit={onSubmitForm} onCancel={onCancelForm} isLoading={isLoading} isSubmiting={isSubmiting} >
            <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <span style={{ display: 'ruby' }}>
                        تصویر شناسنامه  <input data-index={0} key={0} name="File1Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                    </span>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12}>
                    <span style={{ display: 'ruby' }}>
                        تصویر کارت ملی  <input data-index={1} key={1} name="File2Img" placeholder="عکس" onChange={convertToBase64} type="file" accept="image/" />
                    </span></Col>
            </Row>

            <Row style={{marginTop:'10px'}}>
                <Col lg={12} md={12} sm={12} xs={12}>
                    {showImg[0] && (
                        <div style={{display:'flex',alignContent:'center'}}>
                            <img src={files[0].base64File} alt={files[0].base64File} />
                        </div>
                    )}
                </Col>
                <Col lg={12} md={12} sm={12} xs={12} >
                    {showImg[1] && (
                        <div>
                            <img src={files[1].base64File} alt={files[1].base64File} />
                        </div>
                    )}
                </Col>
            </Row>
            </FormContainer>
        </>
    )
}

export default NewPaymentRequestFiles;




